import { render } from "./EditView.vue?vue&type=template&id=6c36d7e8&scoped=true"
import script from "./EditView.vue?vue&type=script&lang=js"
export * from "./EditView.vue?vue&type=script&lang=js"

import "./EditView.vue?vue&type=style&index=0&id=6c36d7e8&scoped=true&lang=css"

import exportComponent from "/Users/rose/src/golinks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c36d7e8"]])

export default __exports__